const INITIAL_STATE = {
  roles: [],
  buckets: [],
};

/**
 * Types
 */
export const Types = {
  GET_RESPONSIBILITY_REQUEST: 'companyResponsibility/GET_RESPONSIBILITY_REQUEST',
  GET_RESPONSIBILITY_SUCCESS: 'companyResponsibility/GET_RESPONSIBILITY_SUCCESS',
  SET_RESPONSIBILITY_REQUEST: 'companyResponsibility/SET_RESPONSIBILITY_REQUEST',
  SET_RESPONSIBILITY_SUCCESS: 'companyResponsibility/SET_RESPONSIBILITY_SUCCESS',
};

/**
 * Reducer
 */
export default function companyResponsibility(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_RESPONSIBILITY_SUCCESS: {
      return { ...state, roles: action.payload.roles, buckets: action.payload.buckets };
    }
    case Types.SET_RESPONSIBILITY_SUCCESS: {
      return { ...state };
    }
    default:
      return state;
  }
}

/**
 * Actions Creators
 */
export const Creators = {
  getResponsibilitiesRequest: () => ({
    type: Types.GET_RESPONSIBILITY_REQUEST,
  }),
  getResponsibilitiesSuccess: payload => ({
    type: Types.GET_RESPONSIBILITY_SUCCESS,
    payload,
  }),
  setResponsibilitiesRequest: payload => ({
    type: Types.SET_RESPONSIBILITY_REQUEST,
    payload,
  }),
  setResponsibilitiesSuccess: payload => ({
    type: Types.SET_RESPONSIBILITY_SUCCESS,
    payload,
  }),
};
